import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Stack,
  TextField,
} from "@mui/material";
import { GetPDFSorteo, GetSorteos } from "../actions/actions";
import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { esES } from "@mui/x-data-grid/locales";
import { ISorteo } from "../interfaces/interfaces";
import { COLUMNS_SORTEOS } from "./columnsTable";
import { pdfjs, Document, Page } from "react-pdf";
import type { PDFDocumentProxy } from "pdfjs-dist";
import moment from "moment";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

interface Props {
  handleClose: (close: boolean) => void;
}

type PDFFile = string | File | null;
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const options = {
  cMapUrl: "/cmaps/",
  standardFontDataUrl: "/standard_fonts/",
};

interface Props2 {
  VerPDF(
    id: number,
    cantLoteria: number,
    NroSorteo: number,
    modalidad: number,
    fecha: string
  ): void;
  sorteo: ISorteo;
}

const DialogContentBuscar = (props: Props) => {
  const { handleClose } = props;
  const [sorteos, setSorteos] = useState<Props2[]>([]);
  const [file, setFile] = useState<PDFFile>(null);
  const [numPages, setNumPages] = useState<number>();
  const [fechaDesde, setFechaDesde] = useState(moment().format("YYYY-MM-DD"));
  const [fechaHasta, setFechaHasta] = useState(moment().format("YYYY-MM-DD"));

  useEffect(() => {
    GetSorteos({
      fechaDesde: fechaDesde,
      fechaHasta: fechaHasta,
      estado: "CONFIRMADO",
    })
      .then((result) => {
        if (result?.data?.length && result.data.length > 0) {
          const { data } = result;
          if (data && data.length > 0) {
            let copia = [
              ...data
                .map((elemento, index) => {
                  if (elemento.ID) {
                    elemento.id = elemento.ID;

                    return { sorteo: elemento, VerPDF: GetPDF };
                  } else return null;
                })
                .filter(Boolean), // Elimina elementos nulos del arreglo;,
            ] as Props2[];
            copia && copia.length > 0 && setSorteos(copia);
          } else {
            setSorteos([]);
          }
        }
      })
      .catch((error) => {
        setSorteos([]);
      });
  }, [fechaDesde, fechaHasta]);

  function onDocumentLoadSuccess({
    numPages: nextNumPages,
  }: PDFDocumentProxy): void {
    setNumPages(nextNumPages);
  }

  const GetPDF = (
    id: number,
    cantLoteria: number,
    NroSorteo: number,
    modalidad: number,
    fecha: string
  ) => {
    GetPDFSorteo(id, cantLoteria, NroSorteo, modalidad, fecha)
      .then((data) => {
        setFile(`${data}`);
      })
      .catch((error) => {
        console.log("err", error);
      });
  };

  const SubmitAction = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    GetSorteos({
      fechaDesde: fechaDesde,
      fechaHasta: fechaHasta,
      estado: "CONFIRMADO",
    })
      .then((result) => {
        if (result?.data?.length && result.data.length > 0) {
          const { data } = result;
          if (data && data.length > 0) {
            let copia = [
              ...data
                .map((elemento, i) => {
                  if (elemento.ID) {
                    elemento.id = elemento.ID;
                    return { sorteo: elemento, VerPDF: GetPDF };
                  } else return null;
                })
                .filter(Boolean), // Elimina elementos nulos del arreglo;,,
            ] as Props2[];
            copia && copia.length > 0 && setSorteos(copia);
          }
        } else {
          setSorteos([]);
        }
      })
      .catch((error) => {
        setSorteos([]);
      });
  };

  return (
    <>
      <DialogContent style={{ minHeight: "100%" }}>
        {!file && (
          <>
            <div
              style={{
                marginLeft: "1rem",
                fontFamily: "Roboto",
                fontWeight: 900,
                color: "var(--primaryGreenDark)",
                marginBottom: "1rem",
              }}
            >
              Buscar Extracto
            </div>

            <form
              noValidate
              autoComplete="off"
              onSubmit={(e) => SubmitAction(e)}
            >
              <Stack direction={"row"}>
                <Box m={1}>
                  <TextField
                    id="fechaDesde"
                    name="fechaDesde"
                    label="Fecha Desde"
                    value={fechaDesde || ""}
                    variant="outlined"
                    //disabled={stateActivo === false}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(val) => {
                      if (val.target.value) {
                        setFechaDesde(`${val.target.value}`);
                      }
                    }}
                  />
                </Box>
                <Box m={1}>
                  <TextField
                    id="fechaHasta"
                    name="fechaHasta"
                    label="Fecha Hasta"
                    value={fechaHasta || ""}
                    variant="outlined"
                    //disabled={stateActivo === false}
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(val) => {
                      if (val.target.value) {
                        setFechaHasta(`${val.target.value}`);
                      }
                    }}
                  />
                </Box>
                <Box m={1} alignSelf={"center"}>
                  <Button variant="contained" color="success" type="submit">
                    Buscar
                  </Button>
                </Box>
              </Stack>
            </form>
            <div
              style={{
                height: "25rem",
                minHeight: "100%",
              }}
            >
              <DataGrid
                className="tabla"
                rowHeight={35}
                rows={sorteos}
                columns={COLUMNS_SORTEOS}
                autoPageSize={true}
                checkboxSelection={false}
                hideFooterSelectedRowCount={true}
                getRowId={(row) => row.sorteo.ID}
                localeText={esES.components.MuiDataGrid.defaultProps.localeText}
              />
            </div>
          </>
        )}

        {file && (
          <>
            <Stack direction={"row"}>
              <Box m={1}>
                <Button
                  color="warning"
                  variant="outlined"
                  autoFocus
                  onClick={() => setFile(null)}
                >
                  cerrar pdf
                </Button>
              </Box>
            </Stack>
            <Stack>
              <Document
                file={file}
                onLoadSuccess={onDocumentLoadSuccess}
                options={options}
              >
                {Array.from(new Array(numPages), (el, i) => (
                  <Page key={`page_${i + 1}`} pageNumber={i + 1} />
                ))}
              </Document>
            </Stack>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Stack direction={"row"}>
          <Box m={1}>
            <Button
              color="error"
              variant="outlined"
              autoFocus
              onClick={() => handleClose(false)}
            >
              cerrar
            </Button>
          </Box>
        </Stack>
      </DialogActions>
    </>
  );
};

export default DialogContentBuscar;
